import { render, staticRenderFns } from "./NicheSalesFormView.vue?vue&type=template&id=2176fd64&"
import script from "./NicheSalesFormView.vue?vue&type=script&lang=js&"
export * from "./NicheSalesFormView.vue?vue&type=script&lang=js&"
import style0 from "./NicheSalesFormView.vue?vue&type=style&index=0&id=2176fd64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports